import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PowerInputIcon(props: IconProps) {
    return <Icon {...props} iconKey={"power_input"}/>
}
